import React from 'react';
import { motion } from 'framer-motion';
import splitLine from 'ReactApp/Services/MotionHelpers/SplitLine';
import { ShowableProductCard } from 'ReactApp/Ddd/Aggregates/ShowableProductCard';
import { observer } from "mobx-react";

const sentence = {
    visible: {
        transition: {
            delay: 1,
            staggerChildren: 0.05,
            staggerDirection: 1,
        },
    },
}

type StockV3Props = {
    productCard: ShowableProductCard;
}

const StockV3 = observer(({ productCard }: StockV3Props) => {
    if (!productCard || !productCard.stock) {
        return null;
    }

    return (
        <>
            {productCard.stock.isStock && (
                <>
                    <svg className="icon-v1" width="18" height="18">
                        <use xlinkHref="/build/sprite.svg#is-stock-icon"></use>
                    </svg>
                    &nbsp;
                    <motion.div
                        className='stock-v3__label'
                        variants={sentence}
                        initial="hidden"
                        animate="visible"
                    >
                        {splitLine('В наличии')}
                    </motion.div>
                </>
            )}
        </>
    );
});

export default StockV3;
